import type { GdsPlanning } from '~/models'
import { ArrayService } from '../serviceLive'
import { documentId, query, where } from 'firebase/firestore'

export class GdsPlanningService extends ArrayService<GdsPlanning> {
  constructor() {
    super('GdsPlanning')
  }

  public listenForAll(): void {
    const listenQuery = query(this.collection)
    this.listen(listenQuery)
  }

  public listenForIds(gdsPlanningIds: string[]): void {
    const queries = gdsPlanningIds.map(id =>
      query(this.collection, where(documentId(), '==', id)),
    )

    this.listenGroup(queries)
  }
}
